export const alertStoreKey = 'alert';
